import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import TextInput from "../../form/TextInput";

class MembercardForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            {...this.props.getFieldProps("issuelocation.name")}
                            name="issuelocation.name"
                            value={(this.props.values.issuelocation || {}).name}
                            label="Hely"
                            saveChanges={this.props.setFieldValue}
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="barcode"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Vonalkód"
                            disabled={true}
                        />
                    </div>
                </div>
                { this.props.values.user !== null && typeof this.props.values.user !== "undefined" &&
                <div className="row form-row">
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("user.firstname")}
                            name="user.firstname"
                            value={ this.props.values.user.firstname}
                            label="Keresztnév"
                            saveChanges={this.props.setFieldValue}
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("user.lastname")}
                            name="user.lastname"
                            value={ this.props.values.user.lastname}
                            label="Vezetéknév"
                            saveChanges={this.props.setFieldValue}
                            disabled={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        <TextInput
                            {...this.props.getFieldProps("user.email")}
                            name="user.email"
                            value={this.props.values.user.email}
                            label="E-mail"
                            saveChanges={this.props.setFieldValue}
                            disabled={true}
                        />
                    </div>
                </div>
                }
            </form>
        );
    }
}

export default createForm(MembercardForm);
